import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CargomaticModal from 'components/v2/modal';
function ConfirmModalFooter({ affirmative, hideButtonText, onHide, onConfirm, primaryButtonColor, primaryDisabled = false, }) {
    const { t } = useTranslation();
    return ((React.createElement("div", { "data-testid": "div-f874ed5f", className: "flex justify-end items-center space-x-2" },
        React.createElement("button", { "data-testid": "button-ac75ae48", onClick: onHide, className: "button button-secondary" }, hideButtonText || t('CANCEL')),
        React.createElement("button", { "data-testid": "button-6afbdc85", className: primaryButtonColor, disabled: primaryDisabled, onClick: onConfirm }, affirmative || t('OK')))));
}
ConfirmModalFooter.propTypes = {
    hideButtonText: PropTypes.string,
    affirmative: PropTypes.string,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    primaryDisabled: PropTypes.bool,
};
export default function ConfirmModal({ show, title, children, message, reason, hideButtonText, affirmative, onConfirm, onHide, primaryButtonColor, primaryDisabled = false, dataTestId }) {
    const { t } = useTranslation();
    function handleConfirm() {
        onConfirm(reason);
    }
    if (primaryButtonColor === 'red') {
        primaryButtonColor = 'button button-red';
    }
    else {
        primaryButtonColor = 'button button-green';
    }
    return ((React.createElement(CargomaticModal, { dataTestId: dataTestId, backdrop: "static", style: { zIndex: 999999, top: '30%' }, show: show, onHide: onHide, size: "small", title: title || t('CONFIRM'), showCloseButton: true, footer: React.createElement(ConfirmModalFooter, { hideButtonText: hideButtonText, affirmative: affirmative, onConfirm: handleConfirm, onHide: onHide, primaryButtonColor: primaryButtonColor, primaryDisabled: primaryDisabled }) }, children || message)));
}
ConfirmModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    reason: PropTypes.string,
    message: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.string,
    affirmative: PropTypes.string,
    hideButtonText: PropTypes.string,
    primaryButtonColor: PropTypes.string,
    primaryDisabled: PropTypes.bool,
};
ConfirmModal.defaultProps = {
    show: false,
    message: 'Are you sure?',
};
